export const suppressEmployerOnboardingBankInfo = false;
export const suppressInviteEmailLink = false;
export const validateEmployeeEmailLength = false;
export const disableEmployeeEdit = false;
export const employerCustodianInfoTemplate = "AvidiaOnboardingInfo";
export const displayBankAccountHolds = false;